module.exports = __webpack_public_path__ + "static/media/suscripciones.28bf73ab.svg";